// Edit planner for CREATE / ALTER / DROP PACKAGE [BODY] (v2 Slice D8).
//
// PRD: Ralph/DdlStructuralEdit2/PRD.md § Slice D8.
//
// All three ops append a fresh statement after the source statement
// (DSE2-7: no coalescing by default). Oracle-only — non-oracle engines reject
// in the dialect synthesizer.

import { rangeFromOffsets } from '../../../sql-grammar/document/lineIndex';
import type { DdlEdit, PlannedByteEdit } from '../../types';

import { pickAppendInsertion } from './appendInsertion';
import type { DdlEditCtx } from './applyDdlEdit';
import {
  synthesizeAlterPackage,
  synthesizeCreatePackage,
  synthesizeDropPackage,
} from './dialect.package';

type PackageEdit = Extract<
  DdlEdit,
  { op: 'create-package' | 'alter-package' | 'drop-package' }
>;

export function planPackageEdit(
  ctx: DdlEditCtx,
  edit: PackageEdit,
): readonly PlannedByteEdit[] {
  const synth = synthForPackage(ctx, edit);
  const { offset: insertAt, sep, trailSep } = pickAppendInsertion(
    ctx.source,
    ctx.statementInfo.range.endOffset,
  );
  return [{
    range: rangeFromOffsets(ctx.lineIdx, insertAt, insertAt),
    replacement: sep + synth + trailSep,
    rationale: edit.op,
  }];
}

function synthForPackage(ctx: DdlEditCtx, edit: PackageEdit): string {
  switch (edit.op) {
    case 'create-package':
      return synthesizeCreatePackage(ctx.engine, edit.package);
    case 'alter-package':
      return synthesizeAlterPackage(ctx.engine, edit.packageName, edit.change);
    case 'drop-package':
      return synthesizeDropPackage(
        ctx.engine,
        edit.packageName,
        edit.packageKind,
        edit.ifExists ?? false,
      );
  }
}
